import update from '../update';
import Logger from '../logger';

const onLoadHandler = (args) => {
    Logger.log('onLoadHandler called');
    Logger.logToCloser(
        `onLoadHandler: externalTraceId=${Logger.traceId}, args=${JSON.stringify(args)}`
    );
    window.WC.Closer._isInitialized = true;
    document.dispatchEvent(new CustomEvent('WCCloserInitialized'));

    if (args && (!args.pageReload || args.authorizationFailed)) {
        update(args);
        window.closer.openWidget();
    }
};

export { onLoadHandler };
